export const ONBOARDING_WIZARD_FETCH_STEPS = 'ONBOARDING_WIZARD_FETCH_STEPS'
export const ONBOARDING_WIZARD_FETCH_STEP = 'ONBOARDING_WIZARD_FETCH_STEP'
export const ONBOARDING_WIZARD_FETCH_STATUS = 'ONBOARDING_WIZARD_FETCH_STATUS'
export const ONBOARDING_WIZARD_COMPLETE_STEP = 'ONBOARDING_WIZARD_COMPLETE_STEP'
export const ONBOARDING_WIZARD_SKIP = 'ONBOARDING_WIZARD_SKIP'
export const ONBOARDING_WIZARD_SAVE_YOUR_DETAILS = 'ONBOARDING_WIZARD_SAVE_YOUR_DETAILS'
